export const prohibitedWords = [
  'ばか',
  'あほ',
  'くそ',
  'しね',
  'カス',
  'ぶす',
  'デブ',
  'チビ',
  'キモい',
  'うざい'
]
